/* eslint-disable no-undef */

function renderMermaid() {
  mermaid.initialize({
    startOnLoad: true,
    theme: 'base',
    themeVariables: {
      primaryColor: '#E3EDFB',
      secondaryColor: 'white',
      signalColor: '#3483FA',
      actorLineColor: 'rgba(0, 0, 0, 0.55)',
      primaryBorderColor: '#3483FA',
    },
    properties: {
      height: 2000,
    },
  });
  mermaid.run().then(() => {
    const svgs = document.querySelectorAll('.mermaid svg');
    svgs.forEach((svg) => {
      svgPanZoom(svg, {
        zoomEnabled: true,
        controlIconsEnabled: true,
        fit: true,
        center: true,
        minZoom: 0.1,
        maxZoom: 10,
        refreshRate: 'auto',
      });
    });
  }).catch((error) => {
    console.error('Mermaid error', error);
  });
}

module.exports = { renderMermaid };
